export default __webpack_public_path__ + "static/media/Loader.a7dd7dc2.svg";